import { createSelector } from "reselect";
import navigation from "../constants/navigation";

const puzzlesSelector = state => state.puzzles;

export const navigationItems = createSelector(
  puzzlesSelector,
  puzzles => {
      if (puzzles.hasBypassedPuzzles) return Object.values(navigation).map(item => Object.assign({}, item, {isUnlocked: true}));

      return Object.keys(navigation).map(itemKey => {
        const item = navigation[itemKey]
        return {
            rune: item.rune,
            path: item.path,
            title: itemKey,
            isUnlocked: puzzles.solvedPuzzles.indexOf(item.rune) !== -1
        }
    })
  }
    
);


// WEBPACK FOOTER //
// ./src/selectors/navigation.js